import React from 'react';
import CreditData from './CreditData';

const LiabilitiesScreen = () => <CreditData />;

export default LiabilitiesScreen;
